import { render, staticRenderFns } from "./ActivityAlertBox.vue?vue&type=template&id=8d07143c&scoped=true&lang=pug"
import script from "./ActivityAlertBox.vue?vue&type=script&lang=js"
export * from "./ActivityAlertBox.vue?vue&type=script&lang=js"
import style0 from "./ActivityAlertBox.vue?vue&type=style&index=0&id=8d07143c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d07143c",
  null
  
)

export default component.exports